import React, { ReactNode } from 'react'
import { useInView } from '../../hooks/useInView'
import styles from './reveal.module.sass'

// Fades a card up the first time it scrolls into view. CSS turns this off
// under reduced motion and when printing.
export const Reveal = ({ children }: { children: ReactNode }) => {
  const [ref, inView] = useInView<HTMLDivElement>()

  return (
    <div ref={ref} className={inView ? styles.shown : styles.waiting}>
      {children}
    </div>
  )
}
